/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react';
import {
  Avatar,
  Box, Card, CardContent, Container,
  Grid, makeStyles, Typography,
} from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { GetAllMentors } from '../../../services/mentors';

import { SelectedMentor } from './SelectedMentor';

const useStyles = makeStyles((theme) => ({
  side: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.background.info,
  },
  title: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    fontWeight: 500,
    marginLeft: theme.spacing(1),
    color: theme.palette.background.info,
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontSize: '20px',
    fontWeight: 500,
    color: theme.palette.text.default,
    margin: theme.spacing(3, 0, 1, 0),
  },
  mentorsCard: {
    background: theme.palette.background.card,
    borderRadius: '12px',
    margin: theme.spacing(2, 0),
    cursor: 'pointer',
    minHeight: 110,
  },
  mentorCardContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    padding: theme.spacing(2, 2),
  },
  mentorCardTextContainer: {
    textAlign: 'right',
    margin: theme.spacing(1, 2, 0, 1),
  },
  mentorCardTextTitle: {
    fontFamily: 'Raleway',
    fontSize: '20px',
    fontWeight: 500,
    color: theme.palette.text.default,
  },
  mentorCardTextSubtitle: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.default,
  },
  mentorCardTextImg: {
    width: 50,
    height: 50,
  },
}));

export function SideBarMentors() {
  const classes = useStyles();
  const [show, setShow] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState({});
  const [mentorsData, setMentorsData] = useState([]);

  const getMentors = async () => {
    const allMentors = await GetAllMentors();
    setMentorsData(allMentors.data);
    setSelectedMentor(allMentors.data[0]);
    setShow(true);
  };

  const handleClick = (event) => {
    mentorsData.forEach((mentor) => {
      if (mentor.id === event.target.id) {
        setSelectedMentor(mentor);
      }
    });
    setShow(true);
  };

  const mentorCards = mentorsData.map((mentor) => (

    <Card className={classes.mentorsCard} key={mentor.id} id={mentor.id}>
      <CardContent
        id={mentor.id}
        onClick={handleClick}
        className={classes.mentorCardContainer}
      >
        <Avatar
          src={mentor.photo}
          id={mentor.id}
          alt="mentor"
          className={classes.mentorCardTextImg}
        />
        <Box className={classes.mentorCardTextContainer} id={mentor.id}>
          <Typography className={classes.mentorCardTextTitle} id={mentor.id}>
            {mentor.fullName}
          </Typography>
          <Typography className={classes.mentorCardTextSubtitle} id={mentor.id}>
            {mentor.specialty}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  ));

  useEffect(() => {
    getMentors();
  }, []);

  return (
    <div>
      <Box className={classes.titleContainer}>
        <ArrowForwardIosIcon />
        <Typography className={classes.title}>Mentores</Typography>
      </Box>
      <Grid
        container
        direction="column-reverse"
        justifyContent="flex-end"
      >
        <Box>
          {mentorCards}
        </Box>
        <Box>
          {show ? (
            <SelectedMentor mentor={selectedMentor} />
          ) : null}
        </Box>
      </Grid>
    </div>
  );
}
